import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// --- START: ADD THIS LINE ---
// This ensures cookies (like the Sanctum auth session and XSRF-TOKEN)
// are sent with every request automatically.
//window.axios.defaults.withCredentials = true;
// --- END: ADD THIS LINE ---